import {
  Component,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap";

@Component({
  selector: "app-modale-conferma-warning-verbale",
  templateUrl: "./modale-conferma-warning-verbale.component.html",
})
export class ModaleConfermaWarningVerbaleComponent {
  /** testo del warning restituito dal BE (verbale.messaggio) */
  @Input()
  messaggio: string = null;

  /** abilita il "Procedi" (riprova) solo se il primario della risposta non è null */
  @Input()
  confermabile: boolean = true;

  @Output()
  conferma: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild("templateModale", { static: false })
  public modaleTemplate: TemplateRef<any>;
  public modalRef: BsModalRef;

  private config = {
    class: "modal-dialog modal-info",
    animated: true,
  };

  constructor(private modalService: BsModalService) {}

  public openModal(): void {
    this.modalRef = this.modalService.show(this.modaleTemplate, this.config);
  }

  public procedi(): void {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.conferma.emit();
  }

  public annulla(): void {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }
}
